// src-mlr-chakra/components/components.module.js
import config from 'app/config';

import mlrcta from './cta/cta.component';
import mlrfooter from './footer/footer.component';
import mlrvideo from '@common/components/video/video.component';
import countdown from '@common/components/countdown/countdown.component';
import opform from '@common/components/opform/opform.component';

const components = [
  mlrcta,
  mlrfooter,
  mlrvideo,
  countdown,
  opform,
];

export default angular
  .module(`${config.appName}.commonComponents`, components)
  .name;